import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-insurer-details-v2',
  templateUrl: './insurer-details-v2.component.html',
  styleUrls: ['./insurer-details-v2.component.scss']
})
export class InsurerDetailsV2Component implements OnInit {
	_code: string;
	_first: boolean;
	_insuranceType: string;
	params: string;

	constructor() {}

  ngOnInit() {}

	get code(): string {
		return this._code;
	}

	@Input() set code(value: string) {
		this._code = value;
	}

	get first(): boolean {
		return this._first;
	}

	@Input() set first(value: boolean) {
		this._first = value;
	}

	get insuranceType(): string {
		return this._insuranceType;
	}
	@Input() set insuranceType(value: string) {
		this._insuranceType = value;
	}
}
